import React, { useEffect } from "react";

function Loader({ closeLoader }) {
  useEffect(() => {
    setTimeout(() => {
      closeLoader();
    }, 1000);
  });
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
}

export default Loader;
